import { render } from "./SwitchToBnbModal.vue?vue&type=template&id=7501afea&scoped=true&ts=true"
import script from "./SwitchToBnbModal.vue?vue&type=script&lang=ts"
export * from "./SwitchToBnbModal.vue?vue&type=script&lang=ts"

import "./SwitchToBnbModal.vue?vue&type=style&index=0&id=7501afea&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7501afea"]])

export default __exports__